import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["orgSelect", "orgIdsJson", "accessModeRadio"]

  serialize() {
    const accessMode = this.accessModeRadioTargets.find(r => r.checked)?.value
    const selectedIds = accessMode === 'all_organizations' ? [] : ($(this.orgSelectTarget).val() || [])
    this.orgIdsJsonTarget.value = JSON.stringify(selectedIds.map(Number))
    this.orgSelectTarget.removeAttribute("name")
  }
}
